import { Outlet, useLocation, useParams } from "react-router-dom";
import { trackMetaPageView } from "../analytics/metaPixel";
import { resolvePageKeyFromPathname } from "../analytics/pageRegistry";
import { useAuth } from "../auth/useAuth";
import { useProductPageView } from "../hooks/useProductPageView";
import { useRecordDailyAccess } from "../hooks/useRecordDailyAccess";
import ScrollToTop from "./ScrollToTop";
import { useEffect, useMemo } from "react";

const ProductAnalyticsOutlet = () => {
  const location = useLocation();
  const params = useParams();
  const { isAuthenticated } = useAuth();
  useRecordDailyAccess(isAuthenticated);

  const registryEntry = useMemo(
    () => resolvePageKeyFromPathname(location.pathname),
    [location.pathname],
  );

  const entityIds = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(params).filter(([, value]) => Boolean(value)),
      ),
    [params],
  );

  useProductPageView({ registryEntry, entityIds });

  useEffect(() => {
    trackMetaPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
};

export default ProductAnalyticsOutlet;
